<template>
  <div v-if="tasks.length > 0" class="my-4">
    <div class="mt-2 pb-2 w-full overflow-auto">
      <table
        class="table-auto min-w-full divide-y divide-gray-400 border-b border-gray-400 border-collapse rounded-lg"
      >
        <thead>
          <tr class="bg-gray-200 font-bold text-sm text-gray-900">
            <th scope="col" class="px-1 py-2.5 text-left">Name</th>
            <th scope="col" class="px-1 py-2.5 text-left">Date</th>
            <th scope="col" class="px-1 py-2.5 text-left">Status</th>
            <th scope="col" class="px-1 py-2.5 text-left">Ordered by</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(task, index) in tasks"
            :key="index"
            class="odd:bg-white even:bg-slate-100 text-gray-900 text-sm"
          >
            <td class="px-1 py-2.5">
              {{ task.name }}
            </td>
            <td class="px-1 py-2.5">
              {{ task.date }}
            </td>
            <td class="px-1 py-2.5">
              {{ task.status }}
            </td>
            <td class="px-1 py-2.5">
              {{ task.user }}
            </td>
            <td class="px-1 py-2.5 w-10">
              <index-menu-item :links="taskLinks(task)" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div v-if="tasks.length === 0" class="bg-white px-6 py-4 my-4">
    <strong>No tasks found.</strong>
  </div>
</template>

<script>
import IndexMenuItem from "@/Components/IndexMenuItem";

export default {
  components: {
    IndexMenuItem,
  },
  props: {
    tasks: Array,
  },

  methods: {
    taskLinks(task) {
      return {
        "Edit task": route("app.task.edit", task.id),
        "View task": route("app.task.view", { task: task.id, tab: "records" }),
      };
    },
  },
};
</script>
